export const CONTACT_QUIZZI_SUCCESS_MESSAGE_ID =
    "contact-quizzi-request-success";
export const CONTACT_QUIZZI_FAILLURE_MESSAGE_ID =
    "contact-quizzi-request-faillure";
export const CONTACT_QUIZZI_FORM_ID = "contactQuizziForm";
